import { render, staticRenderFns } from "./MarketSegmentFormStep.vue?vue&type=template&id=325d3509"
import script from "./MarketSegmentFormStep.vue?vue&type=script&lang=js"
export * from "./MarketSegmentFormStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports